export default class Locale_ContractVersionRetention {
	NumberOfVersionOfResolutionToKeep: string = "How many versions of the '[[resolution]]' resolution to keep";	
}